export default __webpack_public_path__ + "static/media/goulash_soup_gulyas_leves_bogracsban.c30485b2.jpg";